'use client';
import { StyledContactForm } from '@/components/common/ygen/sections/contact-form/contact-form.style';
import React, { useState, useMemo, useCallback } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useShowSetting } from '@/core/context/ShowSettingProvider';
import Link from 'next/link';
import ReactHtmlParser from 'react-html-parser';
import LargeHeading from '@/components/common/ui/text/LargeHeading';
import FormContact from '@/components/common/form/FormContact';
import getFormData from '@/public/json/forms.json';
import CloseButtonYgen from '@/components/common/ui/buttons/CloseButtonYgen';
import Title from '@/components/common/ui/text/Title';

const ContactForm = ({ data, form_id, interest, asModal, onclick, show, career, topTitle, bottomTitle }) => {
	const settingData = useShowSetting();
	const getSettingData = settingData?.getSettings;
	const [formData] = useState(getFormData);

	// Memoize computed values
	const bannerImge = useMemo(() =>
			data?.images?.list?.find((f) => f?.banner === 'on'),
		[data?.images?.list]
	);

	const resolvedFormId = useMemo(() =>
			form_id || data?.section_data?.form_id || 'contact_form',
		[form_id, data?.section_data?.form_id]
	);

	const resolvedFormData = useMemo(() =>
			formData?.[resolvedFormId] || formData?.contact_form,
		[formData, resolvedFormId]
	);

	const backgroundStyle = useMemo(() => ({
		background: data?.section_data?.description || 'white'
	}), [data?.section_data?.description]);

	const handleClick = useCallback(() => {
		if (onclick) {
			onclick();
		}
	}, [onclick]);

	// Memoize contact information
	const contactInfo = useMemo(() => ({
		phone: getSettingData?.office_phone,
		email: getSettingData?.contact_email,
		location: getSettingData?.office_location,
		mapLink: getSettingData?.google_map_link
	}), [getSettingData]);

	return (
		<StyledContactForm
			style={backgroundStyle}
			className={`ContactForm ${asModal ? 'asModal' : ''}`}
			data-scroll-section
		>
			{asModal && (
				<div className="close-button-ygen" onClick={handleClick}>
					<CloseButtonYgen active={show} color="#152637" />
				</div>
			)}

			<div className="fix-right animated-left" data-scroll data-scroll-direction="horizontal" data-scroll-speed="10">
				<LargeHeading
					textColor="rgba(21, 38, 55, 0.03)"
					text={topTitle || data?.section_data?.subtitle || 'Get in'}
				/>
			</div>
			<div className="fix-left animated-right" data-scroll data-scroll-direction="horizontal" data-scroll-speed="-10">
				<LargeHeading
					textColor="rgba(21, 38, 55, 0.03)"
					text={bottomTitle || data?.section_data?.short_desc || 'Touch'}
				/>
			</div>

			<Container>
				<Row>
					<Col md={asModal ? 7 : 4}>
						{asModal ? (
							<div className="job-conetent">
								<Title
									tag="h3"
									text={data?.title}
									color="#152637"
									margin="0 0 60px"
								/>
								{data?.description && ReactHtmlParser(data?.description)}
							</div>
						) : (
							<div className="d-flex">
								<div className="single-item">
									<div className="icon">
										<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
											<rect width="48" height="48" rx="24" fill="#152637" />
											<path d="M34.4231 29.1458L31.3465 26.0756C30.2477 24.9791 28.3797 25.4178 27.9402 26.8431C27.6106 27.83 26.5118 28.3783 25.5229 28.1589C23.3253 27.6107 20.3585 24.7598 19.8091 22.4572C19.4795 21.4703 20.1388 20.3738 21.1277 20.0449C22.5561 19.6063 22.9956 17.7423 21.8968 16.6458L18.8202 13.5757C17.9412 12.8081 16.6226 12.8081 15.8535 13.5757L13.7658 15.659C11.678 17.852 13.9855 23.6633 19.1499 28.8168C24.3142 33.9703 30.1378 36.3826 32.3354 34.1896L34.4231 32.1063C35.1923 31.2291 35.1923 29.9133 34.4231 29.1458Z" fill="white" />
										</svg>
									</div>
									<div className="content">
										<p>Call Us</p>
										<Link href={`tel:${contactInfo.phone}`}>
											{ReactHtmlParser(contactInfo.phone)}
										</Link>
									</div>
								</div>
								<div className="single-item">
									<div className="icon">
										<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
											<rect width="48" height="48" rx="24" fill="#152637" />
											<path d="M25.4668 26.4072C24.9354 26.7615 24.318 26.9488 23.6815 26.9488C23.045 26.9488 22.4277 26.7615 21.8962 26.4072L13.1422 20.571C13.0937 20.5387 13.0464 20.5049 13 20.4702V30.0333C13 31.1298 13.8898 32 14.9666 32H32.3963C33.4928 32 34.3629 31.1102 34.3629 30.0333V20.4702C34.3165 20.505 34.2691 20.5388 34.2204 20.5712L25.4668 26.4072Z" fill="white" />
											<path d="M13.8366 19.5296L22.5905 25.3658C22.9219 25.5867 23.3017 25.6971 23.6815 25.6971C24.0613 25.6971 24.4411 25.5866 24.7725 25.3658L33.5264 19.5296C34.0503 19.1805 34.363 18.5964 34.363 17.9659C34.363 16.8819 33.4811 16 32.3971 16H14.9659C13.8819 16 13 16.8819 13 17.967C13 18.5964 13.3128 19.1805 13.8366 19.5296Z" fill="white" />
										</svg>
									</div>
									<div className="content">
										<p>Email Us</p>
										<Link href={`mailto:${contactInfo.email}`}>
											{ReactHtmlParser(contactInfo.email)}
										</Link>
									</div>
								</div>
								<div className="single-item">
									<div className="icon">
										<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
											<rect width="48" height="48" rx="24" fill="#152637" />
											<path fillRule="evenodd" clipRule="evenodd" d="M24 12C29.5194 12 34 16.3526 34 21.7143C34 24.5063 32.5659 27.38 30.7653 29.7931C28.2512 33.1634 25.1071 35.6206 25.1071 35.6206V35.6211C24.4606 36.1263 23.5394 36.1263 22.8929 35.6211V35.6206C22.8929 35.6206 19.7488 33.1634 17.2347 29.7931C15.4341 27.38 14 24.5063 14 21.7143C14 16.3526 18.4806 12 24 12ZM24 17.7143C26.2724 17.7143 28.1176 19.5069 28.1176 21.7143C28.1176 23.9217 26.2724 25.7143 24 25.7143C21.7276 25.7143 19.8824 23.9217 19.8824 21.7143C19.8824 19.5069 21.7276 17.7143 24 17.7143Z" fill="white" />
										</svg>
									</div>
									<div className="content">
										<p>Visit Us</p>
										<Link target="_blank" href={contactInfo.mapLink}>
											{ReactHtmlParser(contactInfo.location)}
										</Link>
									</div>
								</div>
							</div>
						)}
					</Col>
					<Col md={asModal ? { span: 4, offset: 1 } : { span: 6, offset: 2 }}>
						<FormContact
							asModal={asModal}
							career={career}
							interest={interest}
							data={formData}
							form_id={resolvedFormId}
							formData={resolvedFormData}
							id={resolvedFormId}
						/>
					</Col>
				</Row>
			</Container>
		</StyledContactForm>
	);
};


export default React.memo(ContactForm);
